import type { RoleName } from '@gonfalon/permissions/internal/types';

import type { MemberFilters } from '#utils/memberUtils';
import { convertLastSeenDateToUnix } from '#utils/memberUtils';

enum MemberInstructionKindForReplacingRoles {
  REPLACE_SOME_MEMBERS_BUILT_IN_ROLES = 'replaceMembersRoles',
  REPLACE_SOME_MEMBERS_CUSTOM_ROLES = 'replaceMembersCustomRoles',
  REPLACE_ALL_MEMBERS_BUILT_IN_ROLES = 'replaceAllMembersRoles',
  REPLACE_ALL_MEMBERS_CUSTOM_ROLES = 'replaceAllMembersCustomRoles',
}

export function getBulkEditMemberRolesSemanticPatchInstructions(
  memberIDs: string[],
  customRoleKeys: string[],
  role: RoleName,
  filter: MemberFilters,
  ignoredMemberIDs?: string[],
) {
  const instructions = [];
  let filtersApplied = {};
  const filterQuery = filter?.get('query');
  const filterRoles = filter?.get('roles').toArray();
  const filterTeamKey = filter?.get('team');
  const filterLastSeenValue = filter?.get('lastSeen');
  let filterLastSeen;
  if (filterLastSeenValue) {
    if (filterLastSeenValue === 'never') {
      filterLastSeen = { never: true };
    } else if (filterLastSeenValue === 'no-data') {
      filterLastSeen = { noData: true };
    } else {
      // construct the object that gets sent to the BE
      filterLastSeen = {
        before: convertLastSeenDateToUnix(filterLastSeenValue),
      };
    }
    filtersApplied = { ...filtersApplied, filterLastSeen };
  }
  if (filterQuery) {
    filtersApplied = { ...filtersApplied, filterQuery };
  }
  if (filterRoles?.length) {
    filtersApplied = { ...filtersApplied, filterRoles };
  }
  if (filterTeamKey) {
    filtersApplied = { ...filtersApplied, filterTeamKey };
  }
  if (!customRoleKeys.length && memberIDs[0] !== '*') {
    instructions.push({
      kind: MemberInstructionKindForReplacingRoles.REPLACE_SOME_MEMBERS_BUILT_IN_ROLES,
      value: role,
      memberIDs,
    });
  } else if (!customRoleKeys.length && memberIDs[0] === '*') {
    instructions.push({
      ...filtersApplied,
      kind: MemberInstructionKindForReplacingRoles.REPLACE_ALL_MEMBERS_BUILT_IN_ROLES,
      value: role,
      ignoredMemberIDs,
    });
  }
  if (customRoleKeys.length && memberIDs[0] !== '*') {
    instructions.push({
      kind: MemberInstructionKindForReplacingRoles.REPLACE_SOME_MEMBERS_CUSTOM_ROLES,
      values: customRoleKeys,
      memberIDs,
    });
  } else if (customRoleKeys.length && memberIDs[0] === '*') {
    instructions.push({
      kind: MemberInstructionKindForReplacingRoles.REPLACE_ALL_MEMBERS_CUSTOM_ROLES,
      values: customRoleKeys,
      ignoredMemberIDs,
      ...filtersApplied,
    });
  }
  return instructions;
}
